import { createAction } from 'redux-actions'
import axios from 'axios';

// 注册用户
export const registarSucceeded = createAction('user/GET_SUCCEEDED')
export const registarFailed = createAction('user/GET_FAILED')

export function fetchRegistar(params) {
  return dispatch => (
    axios.post('/api/register', params)
      .then(response => dispatch(registarSucceeded(response)))
      .catch(error => dispatch(registarFailed(error)))
  )
}
// 得到用户名称集合
export const getUserNameSucceeded = createAction('getUser/GET_SUCCEEDED')
export const getUserNameFailed = createAction('getUser/GET_FAILED')

export function fetchGetUserName() {
  return dispatch => (
    axios.get('/api/find/username')
      .then(response => dispatch(getUserNameSucceeded(response)))
      .catch(error => dispatch(getUserNameFailed(error)))
  )
}
// 得到用户信息
export const getUserinfoSucceeded = createAction('getUser/GET_SUCCEEDED')
export const getUserinfoFailed = createAction('getUser/GET_FAILED')

export function fetchGetUserinfo(params) {
  return dispatch => (
    axios.get('/api/findAllUser', { params })
      .then(response => dispatch(getUserinfoSucceeded(response)))
      .catch(error => dispatch(getUserinfoFailed(error)))
  )
}
// 得到冻结用户的信息
export const getUserFreezeSucceeded = createAction('getUser/GET_SUCCEEDED')
export const getUserFreezeFailed = createAction('getUser/GET_FAILED')

export function fetchGetUserFreeze(params) {
  return dispatch => (
    axios.get('/api/freeze/user', { params })
      .then(response => dispatch(getUserFreezeSucceeded(response)))
      .catch(error => dispatch(getUserFreezeFailed(error)))
  )
}
// 删除用户信息
export const getUserDeleteSucceeded = createAction('getUser/GET_SUCCEEDED')
export const getUserDeleteFailed = createAction('getUser/GET_FAILED')

export function fetchGetUserDelete(params) {
  return dispatch => (
    axios.get('/api/deleteUser', { params })
      .then(response => dispatch(getUserDeleteSucceeded(response)))
      .catch(error => dispatch(getUserDeleteFailed(error)))
  )
}



// WEBPACK FOOTER //
// ./actions/user.js